import { getDisplayRemaining } from '@/services/tariffs/tariffValueNormalizer'

const UNKNOWN_USAGE = Object.freeze({
    lookupKey: null,
    name: null,
    rawUsed: null,
    rawLimit: null,
    rawRemaining: null,
    isUnlimited: false,
    isKnown: false,
})

export function getFeatureUsage(usageMap, featureKey) {
    const row = usageMap instanceof Map ? usageMap.get(featureKey) : undefined

    if (!row) {
        return { ...UNKNOWN_USAGE, lookupKey: featureKey }
    }

    return { ...row, isKnown: true }
}

export function getRemainingForDisplay(usageMap, featureKey) {
    const usage = getFeatureUsage(usageMap, featureKey)
    return getDisplayRemaining(usage)
}
